import {gql} from "@apollo/client";

export const CANCEL_JOB_RUN = gql`
	mutation cancelJobStepRun ($jobStepRunId: Int!) {
		cancelJobStepRun (input: {id: $jobStepRunId}) {
		   cancelJobStepRun {
				success
			}
			errors {
				... on ArgumentError {
					message
				}
			}
		}
	}
`;
